import { changeTarget } from "@/lobby_common/utils/utils"
export default {
  name: "mode15",
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      changeTarget
    };
  },
  computed: {
    lang() {
      return this.$store.getters.getLang;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
  },
  watch: {},
  async created() {
    console.log(this.item, "this.itemthis.item");
  },
  mounted() {},
  methods: {
    
  },
  activated() {},
  beforeDestroy() {

  },
};
